import VueResource from "vue-resource";
import Vue from "vue";

Vue.use(VueResource);

Vue.prototype.CDN_URL =
  process.env.VUE_APP_CDN || "https://cdn." + document.location.host;
Vue.http.options.root =
  process.env.VUE_APP_API || "https://app." + document.location.host + "/api/";
